import { render } from "./AlunoDashboard.vue?vue&type=template&id=51226dda&scoped=true"
import script from "./AlunoDashboard.vue?vue&type=script&lang=js"
export * from "./AlunoDashboard.vue?vue&type=script&lang=js"

import "./AlunoDashboard.vue?vue&type=style&index=0&id=51226dda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51226dda"]])

export default __exports__